<template>
  <background>
    <div class="page">
      <logo v-show="showLogo" />
      <transition name="fade">
        <div class="login" v-show="show" style="animation-duration: 0.8s">
          <ValidationObserver v-slot="{ passes, valid }">
            <div class="login-form">
              <span class="login__recover">{{
                loginTitles["recover-access"]
              }}</span>
              <div class="login__subtitle">
                <div c>{{ loginTitles["send-email"] }}</div>
                <div>{{ loginTitles["recover-link"] }}</div>
              </div>
              <div class="login__recover-group">
                <ValidationProvider
                  name="email"
                  rules="required|email"
                  v-slot="{ errors }"
                  class="login__input-container"
                >
                  <label class="login__input-label">{{
                    loginTitles.email
                  }}</label>
                  <div class="login__input-box">
                    <email class="login__icon" />
                    <input
                      v-model="username"
                      type="email"
                      class="login__input"
                      :class="errors[0] && 'error'"
                      placeholder="example@sellia.com"
                      @keyup.enter="$refs.password.focus()"
                    />
                  </div>
                  <transition name="fade">
                    <span v-if="errors[0]" class="login__input-error">{{
                      errors[0]
                    }}</span>
                  </transition>
                </ValidationProvider>
              </div>
              <button
                :disabled="!valid"
                @click="passes(loginSubmit)"
                class="login__button"
                :class="!valid && 'disabled'"
              >
                {{ loginTitles["restore"] }}
              </button>
              <div class="login__forgot-center">
                <router-link to="/" class="login__forgot-link">
                  {{ loginTitles["back-to-home"] }}
                </router-link>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </transition>
    </div>
  </background>
</template>


<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Logo from './Logo.vue'
import Email from '@/assets/images/email.svg';
import Background from './Background.vue';



export default {
   components: {
    ValidationObserver,
    ValidationProvider,
    Logo,
    Email,
    Background,
  },
  data: () => {
    return {
      username: "",
      show: false,
      showLogo: false,
    };
  },
  computed: {
    loginTitles(){
      return this.$t("login");
    }
  },
  mounted() { 
    setTimeout(() => {
      this.show = true;
      this.showLogo = true;
    }, 300);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/views/_login.scss";
</style>
